import React from "react";
import { Route, Routes } from "react-router-dom";
import { BankAccountsList } from "./containers";

export const BankAccounts = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<BankAccountsList />} />
            </Routes>
        </>
    );
};
